kendo.data.binders.enter = kendo.data.Binder.extend({

    init: function() {
        kendo.data.Binder.fn.init.apply(this, arguments);
        var me = this;
        $(this.element).on("keydown", function(e) {
            //This uses keydown, because keypress isn't reliably fired in IE
            //checking isDefaultPrevented() allows detection of whether a child widget wants to handle enter key
            if (e.keyCode === kendo.keys.ENTER && !e.isDefaultPrevented()) {
                var active = $(document.activeElement);

                // check for textarea or button
                if (!active.is("textarea, button")) {
                    active.blur();
                    e.stopPropagation();
                    e.preventDefault();
                    setTimeout(function() {
                        me.bindings.enter.get();
                    }, 0);
                }
            }
        });
    },

    refresh: function() {}
});